"use strict";
// Provider-agnostic product-analytics facade contract + the safe no-op default.
//
// Vendor SDKs (posthog-js) and custom transports (the UXP fetch capture client,
// the Revit C# mirror) adapt to this shape so call sites stay vendor-neutral.
// Single source of truth for the contract — web and every plugin re-export it
// from here instead of hand-keeping identical copies (ADR-0016). Deps-free leaf.
Object.defineProperty(exports, "__esModule", { value: true });
exports.noopAnalytics = void 0;
// Used before init() runs or when analytics is disabled (no project token).
// Every method is a safe no-op so call sites never need to guard — events fired
// before init (or with analytics off) are silently dropped, never thrown.
exports.noopAnalytics = {
    name: 'noop',
    track: () => { },
    identify: () => { },
    register: () => { },
    reset: () => { },
    isReady: () => false,
};
